<div class="row">
  <div class="col-8">
  </div>
  <div class="col" style="text-align: right;" (click)="close()">
    <!-- <button mat-raised-button  style="color: white; background: red;">CLOSE</button> -->
    <i class="material-icons" style="cursor: pointer; font-size: 40px; color: red;">
      cancel
    </i>
  </div>
</div>
<div class="row">
  <div class="col">
    <h2 style="color: red; text-align: center;">Your clock is behind <span class="material-icons">
        alarm
      </span>
    </h2>
    <h4 style="padding: 10px;">A private connection to Aavin Coimbatore Mobile App can't be established because your
      phone's date and time
      <b>{{today | date: 'medium'}}</b> are incorrect.</h4>
    <h4 style="padding: 10px;">Please correct it before using this app again.</h4>
  </div>
</div>
